import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getSystemPoItemDetailsByPoId = async (poId) => {
  try {
    const response = await apiClient.get(
      `/systemInvoiceManagement/purchaseOrderManagement/po-item-details/${poId}`
    );
    return response.data?.response || response.data?.data || response.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
